import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _typeof from "/app/node_modules/@babel/runtime-corejs2/helpers/typeof";
import _classCallCheck from "/app/node_modules/@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "/app/node_modules/@babel/runtime-corejs2/helpers/createClass";
import _defineProperty from "/app/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.replace";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var DEFAULT_REPLACER = 'Магазин';

var proxyFactory = function proxyFactory(handler) {
  return function (obj) {
    return new Proxy(obj, {
      get: function get(target, prop) {
        if (typeof target[prop] === 'string') {
          return handler(target[prop]);
        }

        return target[prop];
      },
      set: function set(target, property, value) {
        target[property] = value;
        return true;
      }
    });
  };
};

function replaceString(str, dictionary) {
  return str.replace(/<%[\s\S]*?%>/g, function (match) {
    var _dictionary$;

    var idx = match.slice(2, -2).split('_');
    var result = (dictionary === null || dictionary === void 0 ? void 0 : (_dictionary$ = dictionary["".concat(idx[0], "_name_form")]) === null || _dictionary$ === void 0 ? void 0 : _dictionary$[idx[1]][idx[2]]) || '';

    if (idx[3] === 'Upper' && result) {
      result = result[0].toUpperCase() + result.slice(1);
    }

    return result || DEFAULT_REPLACER;
  });
}

export var WordReplacer = /*#__PURE__*/function () {
  function WordReplacer(messages, wordsLocal) {
    _classCallCheck(this, WordReplacer);

    _defineProperty(this, "proxyFactory", proxyFactory(this.handler.bind(this)));

    this.defaultReplacers = _objectSpread({}, wordsLocal);
    this.init = this.init.bind(this);
    this.handler = this.handler.bind(this);
    this.rewMessages = messages;
    this.messages = this.__proxyRecursive(messages);
  }

  _createClass(WordReplacer, [{
    key: "handler",
    value: function handler(str) {
      var dictionary = this.replacers || this.defaultReplacers;
      return replaceString(str, dictionary);
    }
  }, {
    key: "__proxyRecursive",
    value: function __proxyRecursive(obj) {
      var _this = this;

      if (_typeof(obj) !== 'object') {
        return obj;
      }

      if (Array.isArray(obj)) {
        return this.proxyFactory(obj.map(function (el) {
          return _this.__proxyRecursive(el);
        }));
      }

      var wrappedObj = Object.keys(obj).reduce(function (acc, key) {
        if (_typeof(obj[key]) === 'object') {
          return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, _this.__proxyRecursive(obj[key])));
        }

        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, obj[key]));
      }, {});
      return this.proxyFactory(wrappedObj);
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dictionary, i18n) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (dictionary) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                this.replacers = dictionary;
                this.messages = this.__proxyRecursive(this.rewMessages);
                i18n.setLocaleMessage(i18n.locale, this.messages[i18n.locale]);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init(_x, _x2) {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }]);

  return WordReplacer;
}();